import { Box, Text, UserMenu, UserMenuDivider, UserMenuItem } from '@pancakeswap/uikit'
import { getChainId, chains, CHAIN_IMAGES, NATIVE_CURRENCY_MAP, DEFAULT_CHAIN } from 'config/constants/exchange'
import { useTranslation } from 'contexts/Localization'

import Image from 'next/image'
import { setupNetwork } from 'utils/wallet'
import { useNetwork } from 'wagmi'


export const NetworkSelect = () => {
  const { t } = useTranslation()

  return (
    <>
      <Box px="16px" py="8px">
        <Text>{t('Select a Network')}</Text>
      </Box>
      <UserMenuDivider />
      {chains.map((chain) => (
        <UserMenuItem key={chain.id} style={{ justifyContent: 'flex-start' }} onClick={() => setupNetwork(chain.id)}>
          <Image width={24} height={24} src={CHAIN_IMAGES[chain.id]} unoptimized />
          <Text pl="12px">{chain.name}</Text>
        </UserMenuItem>
      ))}
    </>
  )
}

export const NetworkSwitcher = () => {
  const { chain } = useNetwork();

  let networks = chains.filter((items) => chain && items.id === chain.id);
  let networkName = '';
  if (networks && networks[0]) {
    networkName = networks[0].name;
  }
  else {
    let networks = chains.filter((items , key) => items.id === DEFAULT_CHAIN);
    if (networks && networks[0]) {
      networkName = networks[0].name;
    }
  }


  return (
    <UserMenu mr="8px" avatarSrc={CHAIN_IMAGES[getChainId(chain)]} account={networkName} ellipsis={false}>
      {() => <NetworkSelect />}
    </UserMenu>
  )

  return null
}
